import React from "react";
import { IPopupProps, Popup } from "component-library";

import "./VideoOverlayPopup.scss";

export interface IVideoOverlayPopupProps {
  renderPlayer(): JSX.Element;
  hidePopup(): void;
}

export class VideoOverlayPopup extends React.PureComponent<IVideoOverlayPopupProps> {
  public render() {
    const popupProps: IPopupProps = {
      width: { lg: 8, md: 10 },
      close: this.props.hidePopup,
      priority: "high",
      texts: { closePopup: "" },
      hideCloseButton: true,
      className: "c-video-overlay-popup",
    };

    return <Popup {...popupProps}>{this.props.renderPlayer()}</Popup>;
  }
}

export default VideoOverlayPopup;
